/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserStudentListItemViewModel } from "../types/ClassroomUserStudentListItemViewModel.ts";

export const classroomUserStudentListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  personName: z.string().nullish(),
  classStudentId: z.number().int().nullish(),
  classStudentCode: z.string().nullish(),
  classroomDisciplineId: z.optional(z.number().int()),
  grade: z.number().nullish(),
  gradeManual: z.optional(z.boolean()),
  attendance: z.optional(z.boolean()),
}) as unknown as ToZod<ClassroomUserStudentListItemViewModel>;
